import TemplateView from '../../../../../../js/TemplateView'
import UsersFilter from '../../../../../../js/administration/userManagement/components/UsersFilter'
import User from '../../../../../../js/store/User'
import messageResource from '../../../../../../js/messageResource'
import {DEFAULT_USER_SELECTION} from '../constants'
import {getTextForUserSelectionDescription} from '../../../utils'
import {escapeHtmlSymbols} from '../../../../../../js/atUtils'

export default class ICalFeedUserSelector extends TemplateView {
    constructor({
        title,
        onSelectionChanged,
        shared = false,
        setAllUsersIfNoneSelected = true,
    }) {
        super()

        this.params = {
            title,
            shared,
            setAllUsersIfNoneSelected,
        }

        this.state = {
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            userSelection: DEFAULT_USER_SELECTION,
        }

        this.callbacks = {
            onSelectionChanged,
        }

        this.onStateDeeplyChanged(() => this._refresh())
    }

    templateHtml() {
        return `<div class='field'>
                    <div class='titleArea'>
                        <div class='sharedIcon'/>
                        <div class='fieldTitle'/>
                    </div>
                    <div class='fieldInput userSelectorWrapper x-btn-no-border'/>
                    <div class='sharedUserSelectorTip'/>
                </div>`
    }

    afterRender() {
        this.find('.sharedIcon').toggle(this.params.shared)
        this.find('.fieldTitle').text(this.params.title)

        this.$userSelectorWrapper = this.find('.userSelectorWrapper')
        this._initUsersFilter()
        if (this.params.shared) {
            this.find('.sharedUserSelectorTip').text(messageResource.getMessage('icalendar.page.lightbox.url.tip'))
        }
    }

    _initUsersFilter() {
        this.$userSelectorWrapper.empty()

        this.usersFilter = new UsersFilter({
            onChange: (selection) => {
                this.callbacks.onSelectionChanged({
                    all: selection.allSelected,
                    userIds: selection.userIds,
                    groupIds: selection.groupIds,
                    groupType: selection.groupType,
                })
            },
            createSelectionDescription: selection => this._getSelectionDescription(selection),
            showInactiveCheckbox: false,
            setAllUsersIfNoneSelected: this.params.setAllUsersIfNoneSelected,
        }).init(this.$userSelectorWrapper)
    }

    _refresh() {
        if (this.state.userSelection) {
            this.usersFilter.setState({
                users: this.state.users.map(user => new User(user.id, user.firstName, user.lastName, user.middleName, user.username,
                    user.active, user.emailExists, user.userGroupId, user.timeZoneGroupId)),
                userIds: this.state.userSelection.userIds,
                groupIds: this.state.userSelection.groupIds,
                groupType: this.state.userSelection.groupType,
                userGroups: window.SystemSettings.apUGREnabled
                            ? this.state.userGroups : null,
                timeZoneGroups: window.SystemSettings.apTZGEnabled
                                ? this.state.timeZoneGroups : null,
                allSelected: this.state.userSelection.all
            })
        } else {
            this._initUsersFilter()
        }
    }

    _getSelectionDescription(selection) {
        return escapeHtmlSymbols(getTextForUserSelectionDescription({
            all: false,
            users: selection.getSecondLevel(),
            groups: selection.getFirstLevel(),
            groupType: selection.groupType,
        }, this.params.shared
           ? 'icalendar.page.table.user_selection.shared.none'
           : 'icalendar.page.table.user_selection.none'))
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/ICalFeedUserSelector.js